module.exports = __webpack_public_path__ + "static/media/feature-data-liberation.5fad48e7.svg";